/* eslint-disable import/prefer-default-export */
export const ENABLE_DIGITAL_WALLET = 'enable_digital_wallet';
export const FUNNEL_PLAN_SELECTOR = 'funnel_annual_plan_selector';
